import React from 'react';
import { Wrench, Recycle, BookOpen, Settings } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  wrench: Wrench,
  recycle: Recycle, 
  book: BookOpen,
  settings: Settings
};

const Features = () => {
  return (
    <section id="features" className="pad-2xl">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">Why Choose Qubit Center?</h2>
          <p className="body-large max-w-2xl mx-auto">
            Our practical approach combines solid theoretical foundations with 
            hands-on experience and cost-effective recycling techniques.
          </p>
        </div>
        
        <div className="voice-grid max-w-5xl mx-auto">
          {mockData.features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            const colors = ['accent-blue', 'accent-green', 'accent-orange', 'accent-purple'];
            
            return (
              <div key={index} className={`voice-card ${colors[index % colors.length]} hover-lift`}>
                <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6 mx-auto">
                  <IconComponent className="w-8 h-8 text-primary" />
                </div>
                
                <h3 className="heading-3 text-center mb-4">{feature.title}</h3>
                <p className="body-medium text-center">{feature.description}</p>
              </div>
            );
          })}
        </div>
        
        {/* Enrollment Info */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="voice-card accent-grey">
            <div className="text-center mb-8">
              <h3 className="heading-2 mb-2">Course Information</h3>
              <p className="body-medium">Everything you need to know about enrollment</p>
            </div>
            
            <div className="grid md:grid-cols-5 gap-6 text-center">
              <div>
                <div className="heading-2 mb-2">{mockData.enrollment.price}</div>
                <div className="caption">Course Fee</div>
              </div>
              <div>
                <div className="heading-2 mb-2">{mockData.enrollment.duration}</div>
                <div className="caption">Duration</div>
              </div>
              <div>
                <div className="heading-2 mb-2">Online</div>
                <div className="caption">Format</div>
              </div>
              <div>
                <div className="heading-2 mb-2">Yes</div>
                <div className="caption">Certificate</div>
              </div>
              <div>
                <div className="heading-2 mb-2">24/7</div>
                <div className="caption">Support</div>
              </div>
            </div>
            
            <div className="text-center mt-8">
              <button className="btn-primary hover-scale">
                Enroll Today
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;